<div class="main">
    <mat-form-field appearance="fill">
        <mat-label>Favorite food</mat-label>
        <mat-select>
            <mat-option>
                one
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>